module.exports = __webpack_public_path__ + "img/cserweima.8cf3d1ac.jpg";